import { PackageIcon } from 'lucide-react';

export const ProductIcon = PackageIcon;
